/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_PathInputs */

const en_media_path = /** @type {(inputs: Media_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Media Path`)
};

const fr_media_path = /** @type {(inputs: Media_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chemin du média`)
};

const de_media_path = /** @type {(inputs: Media_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medienpfad`)
};

const it_media_path = /** @type {(inputs: Media_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Percorso multimediale`)
};

const ru_media_path = /** @type {(inputs: Media_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Путь к медиафайлу`)
};

const es_media_path = /** @type {(inputs: Media_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ruta de los medios`)
};

const zh_cn2_media_path = /** @type {(inputs: Media_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`媒体路径`)
};

const ja_media_path = /** @type {(inputs: Media_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メディアパス`)
};

const hi_media_path = /** @type {(inputs: Media_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मीडिया पथ`)
};

const pt_pt2_media_path = /** @type {(inputs: Media_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caminho da mídia`)
};

/**
* | output |
* | --- |
* | "Media Path" |
*
* @param {Media_PathInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const media_path = /** @type {((inputs?: Media_PathInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_PathInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_media_path(inputs)
	if (locale === "de") return de_media_path(inputs)
	if (locale === "it") return it_media_path(inputs)
	if (locale === "ru") return ru_media_path(inputs)
	if (locale === "es") return es_media_path(inputs)
	if (locale === "zh-CN") return zh_cn2_media_path(inputs)
	if (locale === "ja") return ja_media_path(inputs)
	if (locale === "hi") return hi_media_path(inputs)
	if (locale === "pt-PT") return pt_pt2_media_path(inputs)
	return en_media_path(inputs)
});